export default {
  hint: 'Confirm the payment with your bank to finish your order.',
  cancel: 'Cancel payment',
};
